<template>
    <ui-modal :width="832" :height="510" spacing="32px 56px 40px" ref="modal">
        <div>
            <!-- * 标题 -->
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("CreateFavorites") }}</div>
            <!-- * 内容 -->
            <div class="mt-[16px]">
                <ui-input v-model="data.name" width="100%" :maxlength="20" :placeholder="$t('FavoritesTitle')" />
                <ui-textarea
                    class="mt-[8px]"
                    v-model="data.descript"
                    :height="256"
                    :maxlength="200"
                    style="--uioption-textarea-spacing-y: 8px"
                    :placeholder="$t('FavoritesDescriptionOptional')" />
            </div>

            <!-- * 按钮组 -->
            <div class="mt-[24px]">
                <UiButton :class="css_button.cancel" size="middle" :width="104" @click="methods.close">{{ $t("Cancel") }}</UiButton>
                <UiButton class="ml-[16px]" size="middle" :width="104" :disabled="disabled" @click="methods.confirm">
                    {{ $t("Confirm") }}
                </UiButton>
            </div>
        </div>
    </ui-modal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal, UiInput, UiButton, UiTextarea } from "various-ui";
//* 样式
import css_button from "@/assets/style/src/button.module.less";

//* 组件属性注册
const emits = defineEmits({
    back: () => true,
    confirm: (_response: { name: string; descript: string }) => true,
});

//* 表单数据
const data = reactive({ name: "", descript: "" });
//* 节点
const modal = ref<InstanceType<typeof UiModal>>();
//* 计算属性
const disabled = computed(() => {
    return !data.name.trim();
});

//* 函数列表
const methods = {
    //* 激活事件
    open: (response?: any) => {
        data.name = response?.name || "";
        data.descript = response?.descript || "";
        modal.value?.openModal();
    },

    //* 关闭事件
    close: () => {
        emits("back");
        modal.value?.closeModal();
    },
    //* 确认事件
    confirm: () => {
        emits("confirm", data);
    },
};

//* 组件属性导出
defineExpose({
    open: methods.open,
    close: methods.close,
});
</script>
